import { useMemo } from "react";

const ZERO_WIDTH_SPACE = "\u200B";

const MAX_TEXT_LENGTH = 20;

const breakWord = (word: string) => {
    if (word.length <= MAX_TEXT_LENGTH) {
        return word;
    }
    const withBreaks = word.replace(
        /([a-zA-Z0-9][^a-zA-Z0-9])/g,
        `$1${ZERO_WIDTH_SPACE}`,
    );
    if (withBreaks.includes(ZERO_WIDTH_SPACE)) {
        return withBreaks;
    }
    return withBreaks.match(/.{1,20}/g)?.join(ZERO_WIDTH_SPACE) ?? "";
};

export function useBreakableText(text: string) {
    return useMemo(() => {
        if (!text) {
            return "";
        }
        return text.split(" ").map(breakWord).join(" ");
    }, [text]);
}
